import Swiper from "swiper/bundle";

export const ArticleFooter = () => {
  const $articleFooter = document.querySelector("footer.article-footer");
  if ($articleFooter) {
    const $articleFooterSwiper = $articleFooter.querySelector(
      ".article-footer__swiper "
    );
    if ($articleFooterSwiper) {
      const swiperConfig = {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 10,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      };
      const swiperObject = new Swiper($articleFooterSwiper, swiperConfig);
    }
  }
};

export default ArticleFooter;
